import type React from 'react';
import * as Icon from 'react-bootstrap-icons';

export interface ButtonOptions {
  keyTranslate: string;
  icon: React.ElementType;
}

export enum ButtonAction {
  clean = 'clean',
  find = 'find',
  new = 'new',
  add = 'add',
  cancel = 'cancel',
  save = 'save',
  delete = 'delete',
  show = 'show',
  return = 'return',
  download = 'download',
  upload = 'upload',
  edit = 'edit',
  previous = 'previous',
  next = 'next',
  file = 'file',
  send = 'send',
  translate = 'translate',
  close = 'close'
}

export const actions: Map<ButtonAction, ButtonOptions> = new Map()
  .set(ButtonAction.add, {
    keyTranslate: 'add',
    icon: Icon.Plus
  })
  .set(ButtonAction.find, {
    keyTranslate: 'find',
    icon: Icon.Search
  })
  .set(ButtonAction.close, {
    keyTranslate: 'close',
    icon: Icon.XCircle
  })
  .set(ButtonAction.cancel, {
    keyTranslate: 'cancel',
    icon: Icon.X
  })
  .set(ButtonAction.delete, {
    keyTranslate: 'delete',
    icon: Icon.Trash
  })
  .set(ButtonAction.save, {
    keyTranslate: 'save',
    icon: Icon.Check2
  })
  .set(ButtonAction.clean, {
    keyTranslate: 'clean',
    icon: Icon.Backspace
  })
  .set(ButtonAction.new, {
    keyTranslate: 'new',
    icon: Icon.Plus
  })
  .set(ButtonAction.show, {
    keyTranslate: 'show',
    icon: Icon.Eye
  })
  .set(ButtonAction.download, {
    keyTranslate: 'download',
    icon: Icon.ArrowDown
  })
  .set(ButtonAction.upload, {
    keyTranslate: 'upload',
    icon: Icon.Upload
  })
  .set(ButtonAction.return, {
    keyTranslate: 'return',
    icon: Icon.ArrowReturnLeft
  })
  .set(ButtonAction.edit, {
    keyTranslate: 'edit',
    icon: Icon.Pencil
  })
  .set(ButtonAction.file, {
    keyTranslate: 'file',
    icon: Icon.Paperclip
  })
  .set(ButtonAction.send, {
    keyTranslate: 'send',
    icon: Icon.CloudArrowUpFill
  })
  .set(ButtonAction.previous, {
    keyTranslate: 'previous',
    icon: Icon.CaretLeft
  })
  .set(ButtonAction.next, {
    keyTranslate: 'next',
    icon: Icon.CaretRight
  })
  .set(ButtonAction.translate, {
    keyTranslate: 'translate',
    icon: Icon.Globe
  });
